import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FullCatalogPage = lazy(() => import('~/features/content-enrichment/pages/full-catalog-page'));

/** Step 3 — Full Catalog Generation page for the Google Ads enrichment funnel. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/full',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FullCatalogPage />
    </Suspense>
  ),
});
